import { useEffect } from "react";
import { handlePreview } from "@agility/nextjs";
import { useRouter } from "next/router";
import Error from "next/error";
import SEO from "./SEO";
import Header from "./HeaderNew/Header";
import Footer from "./FooterNew/Footer";
import MainTemplate from "../agility-pageTemplates/MainTemplate";
import LoadingWidget from "./LoadingWidget";
import GoToTop from "./GoToTop/GoToTop";
import { LabelsProvider } from "src/context/LabelsContext";
import { getSiteMapNestedShowOnMenu } from "src/helpers/utils";
import Head from "next/head";
import HeaderMobile from "./HeaderNew/HeaderMobile";
import AdherencePage from "../agility-pageModules/Adherence/AdherencePage";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

// set up handle preview
const isPreview = handlePreview();

function Layout(props) {
  const {
    page,
    sitemapNode,
    sitemapNested,
    globalData,
    dynamicPageItem,
    labels,
    notFound,
    redirects,
  } = props;
  const isAdherencePage = props.isAdherencePage;

  const header = globalData?.header;
  const navLinks = getSiteMapNestedShowOnMenu(sitemapNested);

  useEffect(() => {
    var redirectItem = redirects?.items.find((i) => {
      const urlWithNoHttp = i.originUrl
        .replace("https://", "")
        .replace("http://", "");
      return window.location.href.indexOf(urlWithNoHttp) > -1;
    });

    if (!!redirectItem && !!redirectItem?.destinationUrl) {
      window.location = redirectItem.destinationUrl.replace("~", "");
    }
  }, []);
  
  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  const router = useRouter();
  if (router.isFallback) {
    return <LoadingWidget message="Loading Page" />;
  }

  // if page not found, throw 404
  if (notFound === true) {
    return <Error statusCode={404} />;
  }

  if (dynamicPageItem?.seo?.metaDescription) {
    page.seo.metaDescription = dynamicPageItem.seo.metaDescription;
  }

  return (
    <>
      <Head>
        {/* <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" /> */}
        {!!GTM_ID && (
          <script
            //strategy="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`,
            }}
          />
        )}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
      </Head>
      <SEO
        title={sitemapNode?.title}
        description={page.seo.metaDescription}
        keywords={page.seo.metaKeywords}
        metaHTML={page.seo.metaHTML}
      />
      <LabelsProvider labels={labels}>
        <div className={`${isAdherencePage ? "tw-flex tw-flex-col tw-min-h-screen" : ""}`}>
          <a href="#main" class="skip-to-content">
            Skip to main content
          </a>
          <header role="banner" id="mitsubishi-header">
            <Header links={[...navLinks]} {...header} />
            <HeaderMobile links={[...navLinks]} {...header} />
          </header>
          {!!isAdherencePage && <AdherencePage header={header} pageProps={props}/>}
          {!isAdherencePage &&
            <div className="container">
              <main id="main">
                <MainTemplate {...props} />
                {page?.pageID == 358 && <GoToTop />} {/* show only for VRF page */}
              </main>
            </div>
          }
          <Footer links={[...navLinks]} {...header} className={`${isAdherencePage ? "lg:!tw-mt-0" : ""}`}/>
        </div>
      </LabelsProvider>
    </>
  );
}

export default Layout;
